export const baseVertex = (userIdChannel, instanceIdAsExtraId = false) => /* glsl */ `
#include <common>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

${userIdChannel ? "attribute uint pickingUserId;" : ""}
${userIdChannel ? "flat varying uint vPickingUserId;" : ""}

${instanceIdAsExtraId ? "flat varying int vgl_InstanceID;" : ""}

void main() {

	#include <uv_vertex>
	#include <color_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	
	${userIdChannel ? "vPickingUserId = pickingUserId;" : ""}
	${instanceIdAsExtraId ? "vgl_InstanceID = gl_InstanceID;" : ""}

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>

}
`;
export const baseFragment = (userIdChannel, instanceIdAsExtraId = false) => /* glsl */ `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;

uniform vec3 diffuse;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

#endif

#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

${userIdChannel ? "flat varying uint vPickingUserId;" : ""}
${instanceIdAsExtraId ? "flat varying int vgl_InstanceID;" : ""}

void main() {

	#include <clipping_planes_fragment>

	vec4 diffuseColor = vec4( diffuse, opacity );

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );

	// accumulation (baked indirect lighting only)
	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel= texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;

	#else

		reflectedLight.indirectDiffuse += vec3( 1.0 );

	#endif

	// modulation
	#include <aomap_fragment>

	reflectedLight.indirectDiffuse *= diffuseColor.rgb;

	vec3 outgoingLight = reflectedLight.indirectDiffuse;

	#include <envmap_fragment>

	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

    uint finalExtraId = extraId;
    ${userIdChannel ? "finalExtraId = vPickingUserId;" : ""}
    ${instanceIdAsExtraId ? "finalExtraId = uint(vgl_InstanceID);" : ""}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
}
`;
